import * as React from "react";
import { forwardRef } from "react";
const SvgIcDataInfo20StatusMedium = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 13C9.17157 13 8.5 13.6716 8.5 14.5C8.5 15.3284 9.17157 16 10 16C10.8284 16 11.5 15.3284 11.5 14.5C11.5 13.6716 10.8284 13 10 13ZM9 4V11H11V4H9Z", fill: "#F06710" }));
const ForwardRef = forwardRef(SvgIcDataInfo20StatusMedium);
export { ForwardRef as ReactComponent };
